<template>
  <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk" @cancel="handleCancel" :width="700">
    <div class="modal-content">
      <div class="permission-tree-item" v-for="(item, index) in modal.permissionTree" :key="index">
        <div class="flex justify-between items-center pb-9">
          <div class="title">{{ item.permissionName }}</div>
          <a-button class="app-btn info-btn min-w-min" type="default" @click="selectAll(index)">
            <app-icon type="icon-shezhizuijia"></app-icon>
            全选
          </a-button>
        </div>

        <div>
          <a-checkbox-group
            v-model="modal.optionalSelected[item.permissionId]"
            class="checkbox-vertical px-6 grid grid-cols-4"
          >
            <a-checkbox :value="child.permissionId" v-for="(child, childIndex) in item.children" :key="childIndex">
              {{ child.permissionName }}
            </a-checkbox>
          </a-checkbox-group>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { toolMixin } from '@/utils/mixin'
export default {
  mixins: [toolMixin],
  data() {
    return {
      // 添加送签产品modal
      modal: {
        visible: false,
        title: '',
        data: {},
        permissionTree: [],
        // 顶级菜单直接选中，只有1级目录的，直接选中
        constantSelected: [],
        optionalSelected: {},
      },
    }
  },
  methods: {
    start(row) {
      this.setPower(row)
      return new Promise((resolve, reject) => {
        this.$once('end', function (state, result) {
          if (state === 'ok') {
            resolve(result)
          }
          if (state === 'cancel') {
            reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    async setPower(row) {
      // this.modal.data = row
      this.resetModal$t()
      await this.loadTree(row.roleId)
      this.modal.title = `权限配置`
      this.modal.data = row
      this.modal.visible = true
    },
    async handleOk() {
      const nodeIds = this.getSelectedNode()
      await this.$axios.post('/user/admin/permission/rolePermission', {
        permissionIds: nodeIds,
        roleId: this.modal.data.roleId,
      })
      this.$emit('end', 'ok', {})
    },
    getSelectedNode() {
      const selectedNode = [...this.modal.constantSelected]
      for (const i in this.modal.optionalSelected) {
        if (this.modal.optionalSelected[i].length) {
          selectedNode.push(i)
          this.modal.optionalSelected[i].map((item) => {
            selectedNode.push(item)
          })
        }
      }
      return selectedNode
    },
    handleCancel() {
      this.$emit('end', 'cancel')
    },
    selectAll(index) {
      const id = this.modal.permissionTree[index].permissionId
      this.modal.optionalSelected[id] = this.modal.permissionTree[index].children.map((childNode) => {
        return childNode.permissionId
      })
    },
    async loadTree(id) {
      const res = await this.$axios.get('/user/admin/permission/rolePermission?roleId=' + id)
      const pTree = res.data // 带虚拟1级目录树
      const childTree = pTree[0].children
      const permissionTree = []
      // 顶级目录直接加入
      this.modal.constantSelected.push(pTree[0].permissionId)
      childTree.map((node) => {
        if (node.children.length) {
          permissionTree.push(node)
          const selected = []
          node.children.map((childNode) => {
            console.log(childNode.isSelect)
            if (childNode.isSelect) {
              selected.push(childNode.permissionId)
            }
          })
          console.log(selected)
          this.$set(this.modal.optionalSelected, node.permissionId, selected)
        } else {
          // 没有子菜单的直接加入
          this.modal.constantSelected.push(node.permissionId)
        }
      })
      this.modal.permissionTree = permissionTree
    },
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
::v-deep {
  .ant-checkbox-inner {
    border-radius: 50%;
  }
  .ant-checkbox-checked::after {
    visibility: hidden !important;
  }
}
.modal-content {
  height: 570px;
  overflow: auto;
  padding-right: 30px;
  margin-bottom: 30px;
}
.permission-tree-item {
  border-bottom: 1px solid #dfdfdf;
  padding-bottom: 30px;
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
